const FOCUS_VIEW_EDIT = "edit";
const FOCUS_VIEW_PREVIEW = "preview";

/**
 * @param {unknown} mode
 * @returns {"edit" | "preview"}
 */
function normalizeFocusViewMode(mode) {
  return mode === FOCUS_VIEW_PREVIEW ? FOCUS_VIEW_PREVIEW : FOCUS_VIEW_EDIT;
}

/**
 * @param {{ viewMode?: unknown, composing?: boolean, suggestionCount?: number }} opts
 */
function shouldShowFocusSuggest({ viewMode, composing, suggestionCount }) {
  return (
    normalizeFocusViewMode(viewMode) === FOCUS_VIEW_EDIT &&
    !composing &&
    (suggestionCount || 0) > 0
  );
}

module.exports = {
  FOCUS_VIEW_EDIT,
  FOCUS_VIEW_PREVIEW,
  normalizeFocusViewMode,
  shouldShowFocusSuggest,
};
